module.exports = __webpack_public_path__ + "img/pen.89acff8c.svg";